<template>
  <div class="challenge" :class="{'completed': isCompleted, }">
    <div class="challenge-icon">
      <img
        :src="'/images/challenges/' + challenge.name + '.svg'"
        class="challenge-icon-img"
        :class="{['challenge-icon-' + challenge.name]: true}"
      />
      <div class="challenge-check" :class="{['challenge-check-' + challenge.name]: true}">
        <i class="material-icons challenge-check-icon">check_circle</i>
      </div>
    </div>

    <div class="challenge-title">{{ challenge.title }}</div>
    <div class="challenge-description" v-html="challenge.description"></div>
    <div class="challenge-points">
      <points :count="challenge.points"></points>
    </div>
  </div>
</template>

<script>
import Points from "@/components/Points/Tag";

export default {
  name: "Challenge",
  components: { Points },
  props: ["challenge", "isCompleted"],
  mounted() {}
};
</script>

<style lang="scss" scoped>
.challenge {
  float: left;
  width: 180px;
  height: 210px;
  margin: 8px;
  font-family: $font-family;
}
.challenge-icon {
  padding: 8px;
  text-align: center;
  position: relative;
  height: 140px;
}
.challenge-icon-img {
  position: absolute;
  width: 120px;
  margin-left: 0px;
  top: 0;
  left: 48px;
  opacity: 0.5;
  z-index: 0;
}
.challenge-title {
  margin-top: -24px;
  padding: 0px;
  text-align: center;
  font-size: 14pt;
  font-weight: 600;
  color: lighten($color-blue, 20%);
  color: darken($color-sidebar, 35%);
  color: #666;
}
.challenge-description {
  padding: 2px;
  text-align: center;
  font-size: 12pt;
  font-weight: 500;
  color: #555;
  line-height: 1.3em;
}

.challenge-check {
  position: absolute;
  left: 4px;
  top: 20px;
  height: 112px;
  z-index: 10000 !important;
}
.challenge-check-icon {
  opacity: 0;
  margin-left: 114px;
  color: lighten($color-blue, 6%);
  font-size: 21pt;
  z-index: 10000 !important;
}
.challenge-check-seeing-stars,
.challenge-check-the-right-stuff,
.challenge-check-milky-way {
  left: 0px;
}

.challenge-check-new-author {
  left: 9px;
}
.challenge-check-review-guru {
  left: 2px;
}

.challenge-icon-new-author,
.challenge-icon-first-of-many {
  width: 107px;
  margin-top: 5px;
  margin-left: -9px;
}

.challenge-icon-that-was-easy {
  width: 116px;
  margin-top: 4px;
  margin-left: -12px !important;
}

.challenge-icon-seeing-stars,
.challenge-icon-the-right-stuff,
.challenge-icon-milky-way {
  left: 51px;
}

.completed {
  .challenge-icon-img {
    opacity: 0.9;
  }
  .challenge-check-icon {
    opacity: 1;
  }
  .challenge-title {
    color: $color-blue;
    color: #333;
  }
}
</style>